import React, { useState } from 'react';
import { GuildUser } from '@guildeducationinc/guild-auth';
import { Link } from 'react-router-dom';
import RouteLeavingGuard from '@src/components/Shared/RouteLeavingGuard/RouteLeavingGuard';
import CommunicationSettings from '@src/remotes/CommunicationSettings/CommunicationSettings';

type Props = {
  formData?: GuildUser;
  setCommsShowError: React.Dispatch<React.SetStateAction<any>>;
  setCommsShowSuccess: React.Dispatch<React.SetStateAction<any>>;
};

export const CommunicationSettingsWrapper: React.FC<Props> = ({
  formData,
  setCommsShowError,
  setCommsShowSuccess,
}) => {
  const [isDirty, setIsDirty] = useState(false);

  return (
    <>
      <RouteLeavingGuard when={isDirty} />
      <CommunicationSettings
        formData={formData}
        setIsDirty={setIsDirty}
        setCommsShowError={setCommsShowError}
        setCommsShowSuccess={setCommsShowSuccess}
        reactRouterLink={Link}
      />
    </>
  );
};
